export const addNameValuesForCompanyCategories = (data) => {
    const isChildValid = data && data instanceof Array && data.some((it) => it && (Object.keys(it) || []).length);
  
    if (!isChildValid) {
      return [];
    }
  
    return (data || []).map(({ id: value, categoryName: label }, idx) => ({ ...data[idx], label, value }));
  };
  